<template>
	<v-app theme="dark" style="background-color: #eeeeee">
		<v-main>
			<nav-bar :menuItems="[]" :portalButton="false" hideNotifications></nav-bar>
			<v-container class="fill-height">
				<v-row class="contentRow fill-height">
					<v-col cols="12"></v-col>
					<v-col cols="12" class="d-flex justify-center align-center">
						<v-icon x-large aria-label="email">fas fa-solid fa-envelope-open-text</v-icon>
					</v-col>
					<v-col cols="12">
						<h2 class="mb-5 primary--text text-center">Please verify your email adress</h2>
						<p class="secondary--text text-center">We've sent a verification link to the mail adress you registered with.</p>
						<p class="secondary--text text-center"><router-link to = "/login">Go to login</router-link></p>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<test-error />
	</v-app>
</template>

<script>
import NavBar from "../../components/NavBar.vue"

export default{
	name: "VerifyEmailView",
	components: {NavBar},
}
</script>
